import React from 'react';
import PropTypes from 'prop-types';
import {inject} from '@morningtrain/react-decorators';

export default @inject(['label'])
class Label extends React.Component {

  render() {
    return this.props.label.get();
  }
}

Label.propTypes = {
  label: PropTypes.object.isRequired,
};
